import { Button, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { welldesignModalUpdated, getDesigns } from 'src/store/entities/campaigns/campaigns';
import { ConnectedProps, connect } from 'react-redux';
import { selectHierarchyTableModalVisible } from 'src/store/entities/campaigns/selectors';
import type { TFunction } from 'i18next';
import translations from 'src/internationalisation/translation-map.json';
import type { TRootState } from 'src/store/store-types';
import { convertToKebabCase } from 'client/common/utils/string-utils';
import { HierarchyTableModal } from '../hierarchy-table/hierarchy-table.modal';

type TButtonWithHierarchyModal = PropsFromRedux & {
  name: string;
  campaignId: string;
  companyId: string;
  t: TFunction;
};

const ButtonWithHierarchyModal = ({
  welldesignModalUpdated,
  hierarchyTableModalVisible,
  name,
  campaignId,
  getDesigns,
  companyId,
  t,
}: TButtonWithHierarchyModal) => {
  const handleOnClick = () => {
    welldesignModalUpdated(true);
    getDesigns(companyId, campaignId);
  };

  return (
    <>
      <Button
        name="addEstimates"
        label={t(translations.addItem) as string}
        colored
        onClick={handleOnClick}
        testId={`campaigns-button-${convertToKebabCase(t(translations.addItem))}`}
      />

      {hierarchyTableModalVisible ? (
        <HierarchyTableModal setModalVisible={welldesignModalUpdated} name={name} campaignId={campaignId} />
      ) : null}
    </>
  );
};

const mapStateToProps = ({ entities }: TRootState) => {
  const hierarchyTableModalVisible = selectHierarchyTableModalVisible(entities);
  return {
    hierarchyTableModalVisible,
  };
};

const mapDispatchToProps = {
  welldesignModalUpdated,
  getDesigns,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Container = withErrorBoundary(connector(ButtonWithHierarchyModal), {
  style: { position: 'absolute', bottom: 0, zIndex: 1000 },
});

export { Container as ButtonWithHierarchyModal };
